import { Button, Flex, Text } from '@chakra-ui/react';
import { FC } from 'react';
import Title from '../UI/Title';

const EMPTY_STATE_MESSAGE =
  "Oops! It seems we couldn't find any matching results";

interface ProductListEmptyQueryStateProps {
  onClearFilters?: () => void;
}
const ProductListEmptyQueryState: FC<ProductListEmptyQueryStateProps> = ({
  onClearFilters,
}) => {
  return (
    <Flex flexDir="column" alignItems="center" gap="1.5rem" py="2.5rem">
      <Flex flexDir="column" alignItems="center" gap="0.75rem">
        <Title as="p" fontSize="1.125rem" lineHeight="1.5rem">
          No Matching Result
        </Title>
        <Text
          textAlign="center"
          w="32rem"
          maxW="90%"
          color="grey.700"
          fontSize="1rem"
          fontWeight="300"
          lineHeight="1.5rem"
        >
          {EMPTY_STATE_MESSAGE}
        </Text>
      </Flex>
      {!!onClearFilters && (
        <Button variant="secondaryMd" onClick={onClearFilters}>
          Clear all filters
        </Button>
      )}
    </Flex>
  );
};

export default ProductListEmptyQueryState;
